import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SectionHeading } from "@/components/SectionHeading";
import { useContent } from "@/lib/useContent";
import { usePageMeta } from "@/lib/seo";

const CATS = ["All", "Visa Updates", "Travel Tips", "Destination Guides", "Holiday Inspiration", "Airline Updates", "Travel Requirements"];

export default function Blog() {
  usePageMeta("Travel Blog", "Travel tips, visa guides and destination inspiration from the Makchester Tours & Travel team.");
  const posts0 = useContent("blogs");
  const [cat, setCat] = useState("All");
  const posts = posts0.filter((b) => cat === "All" || b.category === cat);
  return (
    <div className="bg-white">
      <section className="py-20 lg:py-24 bg-[#F9FAFB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading eyebrow="Travel Blog" title="Stories, tips & visa updates" subtitle="Written by the consultants who book your trips every day." />
          <div className="flex flex-wrap justify-center gap-2">
            {CATS.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`blog-cat-${c.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors ${cat === c ? "bg-[#0A2E4D] text-white" : "bg-white border border-[#E5E7EB] text-[#4B5563] hover:border-[#D4A62A]"}`}>{c}</button>
            ))}
          </div>
        </div>
      </section>
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((b) => (
            <Link key={b.slug} to={`/blog/${b.slug}`} className="mk-card overflow-hidden group" data-testid={`blog-list-card-${b.slug}`}>
              <div className="h-52 overflow-hidden"><img src={b.image} alt={b.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" /></div>
              <div className="p-7">
                <div className="text-[11px] uppercase tracking-[0.2em] text-[#D4A62A] font-bold">{b.category}</div>
                <h3 className="font-serif-display text-xl text-[#0A2E4D] mt-2 leading-snug">{b.title}</h3>
                <p className="text-sm text-[#4B5563] mt-3 leading-relaxed line-clamp-3">{b.excerpt}</p>
                <div className="text-xs text-[#9CA3AF] mt-4">{b.date} · {b.read}</div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
